// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610200340/js/" + chunkId + "." + {"44":"0b3eb55b","225":"ae9bc20e","481":"d56043a9","486":"c618f319","770":"3becadc4"}[chunkId] + ".0.7323867001168751.chunk.js";
};